import { useInstance } from '@meraki-internal/react-dependency-injection';
import { LocationSearch } from '../../components/search/LocationSearch.tsx';
import { ICoordinate } from '../../support/model/ICoordinate.ts';
import { ILocation } from '../../support/model/ILocation.ts';
import { ISuggestion } from '../../support/model/ISuggestion.ts';
import { usePageView } from '../../support/tracking/usePageView.tsx';
import { LocationSearchService } from './LocationSearchService.ts';
import { useBreakpoints } from '../../support/hooks/useBreakpoints.tsx';

export interface LocationSearchPanelProps {
    onSelect: (location?: ILocation) => Promise<void>;
    onChange: (searchText: string) => void;
    onCoordinates: (coordinates: ICoordinate) => void;
    sessionToken: string;
}

export const LocationSearchPanel: React.FC<LocationSearchPanelProps> = ({ onSelect, onChange, onCoordinates, sessionToken }) => {
    usePageView('Map');

    const locationSearchService = useInstance(LocationSearchService);

    const { isLargerScreen } = useBreakpoints();

    const matchesToReturn = !isLargerScreen ? 5 : 10;

    const handleSearch = async (searchText: string): Promise<ISuggestion[]> => {
        onChange(searchText);
        return await locationSearchService.suggest({ searchText, matchesToReturn, sessionToken });
    };

    const handleSelect = async (suggestion?: ISuggestion) => {
        if (suggestion) {
            const coordinates = await locationSearchService.retrieve({ id: suggestion.id, sessionToken });
            onSelect({ address: suggestion.address, coordinates });
        } else {
            onSelect(undefined);
        }
    };

    return (
        <LocationSearch onSearch={handleSearch} onSelect={handleSelect} onCoordinates={onCoordinates} />
    );
};
